/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from "@angular/core";

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(JobTitlesDataService.Id, JobTitlesDataService);

    JobTitlesDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class JobTitlesDataService extends base.BaseDataService<Nema.Crew.Model.JobType> implements IJobTitleDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "jobTitleDataService";

    public get EntityName(): string {
        return "JobType";
    }

    public get EntitiesName(): string {
        return "JobTypes";
    }
}

export interface IJobTitleDataService extends base.IDataService<Nema.Crew.Model.JobType> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/jobtitles.dataservice.ts